/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Tax applied to an order entry or additional cost by the pricing engine.
 * @export
 * @interface SAPAppliedTax
 */
export interface SAPAppliedTax {
    /**
     * Tax code identifier.
     * @type {string}
     * @memberof SAPAppliedTax
     */
    code?: string;
    /**
     * Tax amount.
     * @type {number}
     * @memberof SAPAppliedTax
     */
    value?: number;
}

/**
 * Check if a given object implements the SAPAppliedTax interface.
 */
export function instanceOfSAPAppliedTax(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SAPAppliedTaxFromJSON(json: any): SAPAppliedTax {
    return SAPAppliedTaxFromJSONTyped(json, false);
}

export function SAPAppliedTaxFromJSONTyped(json: any, ignoreDiscriminator: boolean): SAPAppliedTax {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : json['code'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function SAPAppliedTaxToJSON(value?: SAPAppliedTax | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'value': value.value,
    };
}

